import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner.jsx';
import { FilterProvider } from './context/FilterContext.js';
import Login from './pages/Login.js';
import Dashboard from './pages/Dashboard.js';
import HRDashboard from './pages/HRDashboard.js';
import ESGDashboard from './pages/ESGDashboard.js';
import SalaryDashboard from './pages/SalaryDashboard.js';
import BenefitsDashboard from './pages/BenefitsDashboard.js';
import Empresas from './pages/Empresas.js';
import Headcount from './pages/Headcount.js';
import AcordosColetivos from './pages/AcordosColetivos.js';
import Relatorios from './pages/Relatorios.js';
import Configuracoes from './pages/Configuracoes.js';
import Pesquisas from './pages/Pesquisas.js';
import ResponderPesquisa from './pages/ResponderPesquisa.js';
import MinhaEmpresa from './pages/MinhaEmpresa.js';
import CompanyRegister from './pages/CompanyRegister.js';
import CustomIndicators from './pages/CustomIndicators.js';
import CargosPadrao from './pages/CargosPadrao.js';
import LandingPage from './pages/LandingPage.js';
import Diagnosticos from './pages/Diagnosticos.js';
import ResponderDiagnostico from './pages/ResponderDiagnostico.js';
import DiagnosticoResultados from './pages/DiagnosticoResultados.js';
import DiagnosticoPublico from './pages/DiagnosticoPublico.js';
import './App.css';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? <FilterProvider>{children}</FilterProvider> : <Navigate to="/login" replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<CompanyRegister />} />
          <Route path="/d/:token" element={<DiagnosticoPublico />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/empresas" element={<PrivateRoute><Empresas /></PrivateRoute>} />
          <Route path="/indicadores-rh" element={<PrivateRoute><HRDashboard /></PrivateRoute>} />
          <Route path="/headcount" element={<PrivateRoute><Headcount /></PrivateRoute>} />
          <Route path="/esg-pessoas" element={<PrivateRoute><ESGDashboard /></PrivateRoute>} />
          <Route path="/remuneracao" element={<PrivateRoute><SalaryDashboard /></PrivateRoute>} />
          <Route path="/beneficios" element={<PrivateRoute><BenefitsDashboard /></PrivateRoute>} />
          <Route path="/acordos-coletivos" element={<PrivateRoute><AcordosColetivos /></PrivateRoute>} />
          <Route path="/relatorios" element={<PrivateRoute><Relatorios /></PrivateRoute>} />
          <Route path="/pesquisas" element={<PrivateRoute><Pesquisas /></PrivateRoute>} />
          <Route path="/responder-pesquisa/:surveyId" element={<PrivateRoute><ResponderPesquisa /></PrivateRoute>} />
          <Route path="/minha-empresa" element={<PrivateRoute><MinhaEmpresa /></PrivateRoute>} />
          <Route path="/indicadores-customizados" element={<PrivateRoute><CustomIndicators /></PrivateRoute>} />
          <Route path="/cargos-padrao" element={<PrivateRoute><CargosPadrao /></PrivateRoute>} />
          <Route path="/diagnosticos" element={<PrivateRoute><Diagnosticos /></PrivateRoute>} />
          <Route path="/diagnosticos/:diagnosticId/responder" element={<PrivateRoute><ResponderDiagnostico /></PrivateRoute>} />
          <Route path="/diagnosticos/:diagnosticId/resultados" element={<PrivateRoute><DiagnosticoResultados /></PrivateRoute>} />
          <Route path="/configuracoes" element={<PrivateRoute><Configuracoes /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
